<template>
  <b-row>
    <b-col>
      <h6 class="compo-heading">{{ t('5003.unitoftransaction.title') }}</h6>
    </b-col>
  </b-row>
  <div class="details-card">
    <b-row>
      <b-col lg="12" md="12" sm="12" cols="12" class="addcircle_field" v-if="PackSizeHide">
        <div class="field">
          <CustomDropDown :modelValue="Unitoftransactions.PackSizeId || undefined"
            @update:modelValue="value => updateField('PackSizeId', value)"
            :items="PackageSizeDropdown.PackageSizeoption" @change="PackageSizeOnChange"
            :label="t('5003.unitoftransaction.packsize')" name="Package Size" id="Package Size"
            :rules="{ required: true }" :required-icon="true" :tabindex="17" />
        </div>
        <span class="add_circle" @click="FunctionRights(EntityIds.PackSize, 'PackSize')"><i
            class="pi pi-plus"></i></span>
      </b-col>
      <b-col lg="12" md="12" sm="12" cols="12">
        <div class="field">
          <CustomDropDown :modelValue="Unitoftransactions.OrderUnitId || undefined"
            @update:modelValue="value => updateField('OrderUnitId', value)" :items="OrderingUnitDropdown.Orderingoption"
            @change="OrderingUnitOnChange" :label="t('5003.unitoftransaction.orderingunit')" name="Ordering Unit"
            id="Ordering Unit" :rules="{ required: true }" :required-icon="true" :tabindex="18" />
        </div>
      </b-col>
      <b-col lg="12" md="12" sm="12" cols="12" class="addcircle_field">
        <div class="field">
          <CustomDropDown :modelValue="Unitoftransactions.UnitId || undefined"
            @update:modelValue="value => updateField('UnitId', value)" :items="DispensingUnitDropdown.Dispensingoption"
            @change="DispensingUnitOnChange" :label="t('5003.unitoftransaction.dispensingunit')" name="Dispensing Unit"
            id="Dispensing Unit" :rules="{ required: true }" :required-icon="true" :tabindex="19" />
        </div>
        <span class="add_circle" @click="FunctionRights(EntityIds.Unit, 'Unit')"><i class="pi pi-plus"></i></span>
      </b-col>
      <b-col lg="12" md="12" sm="12" cols="12">
        <div class="field">
          <CustomDropDown :modelValue="Unitoftransactions.BaseUOMId || undefined"
            @update:modelValue="value => updateField('BaseUOMId', value)" :items="BaseUOMDropdown.BaseUOMoption"
            :label="t('5003.unitoftransaction.baseuom')" name="baseuom" id="baseuom" :rules="{ required: true }"
            :required-icon="true" :tabindex="18" />
        </div>
      </b-col>
    </b-row>
  </div>
  <Packcreation v-model:trigger="DialogShow.PackSize" v-if="DialogShow.PackSize"
    @load="LoadPackageSize(), (DialogShow.PackSize = false)" @close="DialogShow.PackSize = false"
    :OperationID="ObjOperationId" :EntityId="EntityIds.PackSize" />
  <Unitcreastion v-model:trigger="DialogShow.Unit" v-if="DialogShow.Unit"
    @load="LoadOrderingDispensing(), (DialogShow.Unit = false)" @close="DialogShow.Unit = false"
    :OperationID="ObjOperationId" :EntityId="EntityIds.Unit" />
  <Toast />
</template>

<script lang="ts">
import { defineComponent, ref, reactive, toRefs, onMounted, watch, PropType } from "vue";
import { useI18n } from "vue-i18n";
import service from "../../Service/ItemMasService";
import CustomDropDown from "../../../../components/FormComponents/Dropdown.vue";
import Packcreation from "../../../../modules/Inventory/pages/Masters/Items/PackSizeMaster/PackSizeCreation.vue";
import MastersService from "../../../../modules/Inventory/Service/MastersService";
import { checkPermission } from "../../../../modules/Inventory/Service/AccessControl";
import { useToast } from "primevue/usetoast";
import Unitcreastion from "../../../../modules/Inventory/pages/Masters/Items/UnitMaster/UnitCreation.vue";
import { useRoute } from "vue-router";

interface DropdownOption {
  Id: number;
  Name: string;
  name: string;
  value: number;
  Type?: number;
  IsActive: boolean;
  HospitalId: number;
  [key: string]: any;
}

interface Selection {
  value: number;
  [key: string]: any;
}

interface UnitTransactions {
  PackSizeId: number | null;
  OrderUnitId: number | null;
  UnitId: number | null;
  DispenseInNumber: boolean;
  BaseUOMId: number | null;
}

export default defineComponent({
  name: 'UnitOfTransactions',
  components: {
    CustomDropDown,
    Packcreation,
    Unitcreastion
  },

  props: {
    modelValue: {
      type: Object as PropType<UnitTransactions>,
      default: () => ({
        PackSizeId: null,
        OrderUnitId: null,
        UnitId: null,
        DispenseInNumber: true,
        BaseUOMId: null
      })
    },
    PackSizeHide: {
      type: Boolean,
      default: true,
    },
  },

  setup(props, { emit }) {
    const { t } = useI18n();
    let session: any = localStorage.getItem("UsersData");

    const toast = useToast();
    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);

    let Unitoftransactions = reactive<UnitTransactions>({
      PackSizeId: null,
      OrderUnitId: null,
      UnitId: null,
      DispenseInNumber: true,
      BaseUOMId: null
    });

    function updateField(field: keyof UnitTransactions, value: number | undefined | null) {
      if (field === 'DispenseInNumber' && typeof value === 'boolean') {
        Unitoftransactions[field] = value;
      } else if (field !== 'DispenseInNumber') {
        (Unitoftransactions[field] as number | null) = value ?? null;
      }
      input();
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }
    let Rights = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });
    const copyRights = JSON.parse(JSON.stringify(Rights.value));
    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
    });
    const copyObjOperationId = JSON.parse(JSON.stringify(ObjOperationId.value));
    let DialogShow = ref({
      PackSize: false,
      Unit: false
    });
    let EntityIds = ref({
      PackSize: 104,
      Unit: 103
    });
    const route = useRoute();

    onMounted(async () => {
      if (!route.query.id) {
        LoadPackageSize();
        LoadOrderingDispensing();
      }
      Object.assign(Unitoftransactions, props.modelValue);
      input();
    });

    function input() {
      emit("update:modelValue", Unitoftransactions);
    }

    watch(() => props.modelValue, (newValue) => {
      if (newValue) {
        Object.assign(Unitoftransactions, newValue);
      }
    }, { deep: true });

    watch(Unitoftransactions, async (newValue: UnitTransactions) => {
      await LoadPackageSize();
      await LoadOrderingDispensing();

      if (newValue.OrderUnitId && newValue.UnitId) {
        OrderingUnitOnChange({ value: newValue.OrderUnitId });
        DispensingUnitOnChange({ value: newValue.UnitId });
        await LoadBaseUOM();
      }
    }, { deep: true });

    const PackageSizeDropdown = ref({
      PackageSizeid: null as number | null,
      PackageSizeoption: [] as DropdownOption[],
    });

    const OrderingUnitDropdown = ref({
      Orderingid: null as number | null,
      Orderingoption: [] as DropdownOption[],
    });

    const DispensingUnitDropdown = ref({
      Dispensingid: null as number | null,
      Dispensingoption: [] as DropdownOption[],
    });

    const BaseUOMDropdown = ref({
      BaseUOMid: null as number | null,
      BaseUOMoption: [] as DropdownOption[],
    });

    async function LoadPackageSize() {
      try {
        const response = await service.PackageSize();
        PackageSizeDropdown.value.PackageSizeoption = response["result"]
          .filter((f: DropdownOption) => f.IsActive && f.HospitalId === HospitalId)
          .map((item: DropdownOption) => ({
            ...item,
            name: item.Name,
            value: item.Id
          }));
      } catch (error) {
        alert(error);
      }
      input();
    }

    async function LoadOrderingDispensing() {
      try {
        const response = await service.OrderingDispensingUnit();
        const items: DropdownOption[] = response["result"]
          .filter((f: DropdownOption) => f.IsActive && f.HospitalId === HospitalId)
          .map((item: DropdownOption) => ({
            ...item,
            name: item.Name,
            value: item.Id,
            Id: item.Id
          }));

        OrderingUnitDropdown.value.Orderingoption = items;
        DispensingUnitDropdown.value.Dispensingoption = items;
      } catch (error) {
        alert(error);
      }
      input();
    }

    const PackageSizeOnChange = (value: Selection) => {
      if (value?.value) {
        updateField('PackSizeId', value.value);
      }
    };

    const OrderingUnitOnChange = (value: Selection) => {
      if (value?.value) {
        updateField('OrderUnitId', value.value);
      }

      const selectedOrderingUnit = OrderingUnitDropdown.value.Orderingoption
        .filter((item) => item.Id === Unitoftransactions.OrderUnitId)
        .map((item) => ({ ...item, Type: 1 }));

      if (selectedOrderingUnit.length > 0) {
        BaseUOMDropdown.value.BaseUOMoption = BaseUOMDropdown.value.BaseUOMoption
          .filter((item) => item.Type !== 1);

        if (!BaseUOMDropdown.value.BaseUOMoption.find(option => option.Id === selectedOrderingUnit[0].Id)) {
          BaseUOMDropdown.value.BaseUOMoption.push(...selectedOrderingUnit);
        }
      }
    };

    const DispensingUnitOnChange = (value: Selection) => {
      if (value?.value) {
        updateField('UnitId', value.value);
      }

      const selectedDispensingUnit = DispensingUnitDropdown.value.Dispensingoption
        .filter((item) => item.Id === Unitoftransactions.UnitId)
        .map((item) => ({ ...item, Type: 2 }));

      if (selectedDispensingUnit.length > 0) {
        BaseUOMDropdown.value.BaseUOMoption = BaseUOMDropdown.value.BaseUOMoption
          .filter((item) => item.Type !== 2);

        if (!BaseUOMDropdown.value.BaseUOMoption.find(option => option.Id === selectedDispensingUnit[0].Id)) {
          BaseUOMDropdown.value.BaseUOMoption.push(...selectedDispensingUnit);
        }
      }
    };

    async function LoadBaseUOM() {
      BaseUOMDropdown.value.BaseUOMoption = [];

      const selectedOrderingUnit = OrderingUnitDropdown.value.Orderingoption.find(
        (item) => item.Id === Unitoftransactions.OrderUnitId
      );
      const selectedDispensingUnit = DispensingUnitDropdown.value.Dispensingoption.find(
        (item) => item.Id === Unitoftransactions.UnitId
      );

      if (selectedOrderingUnit) {
        const orderingUnitWithType = { ...selectedOrderingUnit, Type: 1 };
        BaseUOMDropdown.value.BaseUOMoption.push(orderingUnitWithType);
      }

      if (selectedDispensingUnit && (!selectedOrderingUnit || selectedDispensingUnit.Id !== selectedOrderingUnit?.Id)) {
        const dispensingUnitWithType = { ...selectedDispensingUnit, Type: 2 };
        BaseUOMDropdown.value.BaseUOMoption.push(dispensingUnitWithType);
      }

      BaseUOMDropdown.value = { ...BaseUOMDropdown.value };
    }

    async function FunctionRights(EntityId: number, FieldType: string) {
      Object.assign(Rights.value, copyRights);
      Object.assign(ObjOperationId.value, copyObjOperationId);

      const response = await MastersService.CheckMenuRights(EntityId, rolesData.RoleId);

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          ObjOperationId.value.CreateId = operation.OperationID;
          Rights.value.Create = operation.IsActive;
        }
        else if (operation.OperationName === "Update") {
          ObjOperationId.value.UpdateId = operation.OperationID;
          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          ObjOperationId.value.ReadId = operation.OperationID;
          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          ObjOperationId.value.DeleteId = operation.OperationID;
          Rights.value.Delete = operation.IsActive;
        }
      }

      let permissionResult: any = checkPermission(Rights, "Add");
      if (permissionResult.hasPermission) {
        DialogShow.value[FieldType] = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    return {
      t,
      ObjOperationId,
      EntityIds,
      DialogShow,
      FunctionRights,
      input,
      Unitoftransactions,
      PackageSizeDropdown,
      LoadPackageSize,
      PackageSizeOnChange,
      OrderingUnitDropdown,
      DispensingUnitDropdown,
      LoadOrderingDispensing,
      OrderingUnitOnChange,
      DispensingUnitOnChange,
      BaseUOMDropdown,
      LoadBaseUOM,
      updateField
    };
  },
});
</script>
